// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"832578d89f78aca9","4603":"a114b9e5bd20b585"}[chunkId] + ".css";
};